import { render } from "./unpublished.vue?vue&type=template&id=6afa39c7"
import script from "./unpublished.vue?vue&type=script&lang=js"
export * from "./unpublished.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__